$(document).ready(function () {
    $('.play-video').on('click', function () {
        $('#homepage-video')[0].src = $('#homepage-video')[0].getAttribute('data-src') + '?rel=0&autoplay=1';
        $('#homepage-video').removeClass('d-none');
        $('.custom-img').addClass('d-none');
    });
});
